<script lang="ts">
  import { PayoutStatusEnum } from "../lib/api/charityServices/payout";

  // Define status types for the badge
  export let status: PayoutStatusEnum | string = PayoutStatusEnum.PENDING;
  export let showIcon: boolean = true;
  export let customClass: string = "";
  
  // Map status to colors
  const getColorClass = (status: PayoutStatusEnum | string): string => {       
    const statusStr = typeof status === 'string' ? status.toUpperCase() : status;
    
    switch (statusStr) {
      case PayoutStatusEnum.COMPLETED:
      case 'COMPLETED':
        return "completed";
      case PayoutStatusEnum.FAILED:
      case 'FAILED':
        return "failed";
      case PayoutStatusEnum.PENDING:
      case 'PENDING':
      default:
        return "pending";
    }
  };

  // Map status to icons
  const getIcon = (status: PayoutStatusEnum | string): { svg: string; label: string } => {
    const statusStr = typeof status === 'string' ? status.toUpperCase() : status;
    
    switch (statusStr) {
      case PayoutStatusEnum.COMPLETED:
      case 'COMPLETED':
        return {  
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>`,
          label: "Completed"
        };
      case PayoutStatusEnum.FAILED:
      case 'FAILED':
        return {
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                </svg>`,
          label: "Failed"
        };
      case PayoutStatusEnum.PENDING:
      case 'PENDING':
      default:
        return {
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
                </svg>`,
          label: "Pending"
        };
    }
  };

  $: colorClass = getColorClass(status);
  $: icon = getIcon(status);
</script>

<div class="payout-status-badge {colorClass} {customClass}">
  {#if showIcon}
    <span class="icon" aria-hidden="true">
      {@html icon.svg}
    </span>
  {/if}
  <span class="text">
    <slot>{status}</slot>
  </span>
</div>

<style>
  .payout-status-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5;
    gap: 0.375rem;
  }

  .icon {
    display: flex;
    align-items: center;
  }

  .text {
    margin-top: 1px;
  }

  /* Status-specific styling — colours from the canonical palette
     (TONE_PALETTE in src/lib/donationLifecycle.ts / lc-tone-* in app.css). */
  .pending {
    background-color: #fef3c7;
    color: #92400e;
  }

  .pending .icon {
    color: #92400e;
  }

  .completed {
    background-color: #d1fae5;
    color: #065f46;
  }

  .completed .icon {
    color: #065f46;
  }

  .failed {
    background-color: #fee2e2;
    color: #991b1b;
  }

  .failed .icon {
    color: #991b1b;
  }
</style> 